import { createAction } from "@reduxjs/toolkit";
import { REDUCER_PREFIX } from "./slice";

export const fetchResultsRequest = createAction(
    `${REDUCER_PREFIX}/fetchResultsRequest`
);